import { isRecord } from "@/lib/tableBlockHelpers";

export type MediaItem = {
  type: "image" | "video";
  value: string;
  index: number;
  caption: string;
};

/** Public URL for a stored upload filename (`value`). */
export function mediaItemSrc(item: MediaItem): string {
  const v = item.value.trim();
  return `/uploads/${encodeURIComponent(v)}`;
}

export function reindexMediaItems(items: MediaItem[]): MediaItem[] {
  return items.map((it, i) => ({ ...it, index: i }));
}

export function normalizeRawMediaList(raw: unknown[]): MediaItem[] {
  const candidates: MediaItem[] = [];
  for (const item of raw) {
    if (!isRecord(item)) continue;
    if (item.type !== "image" && item.type !== "video") continue;
    if (typeof item.value !== "string" || !item.value.trim()) continue;
    const idx =
      typeof item.index === "number" && Number.isFinite(item.index)
        ? item.index
        : 0;
    const caption = typeof item.caption === "string" ? item.caption : "";
    candidates.push({
      type: item.type,
      value: item.value.trim(),
      index: idx,
      caption,
    });
  }
  candidates.sort((a, b) => a.index - b.index);
  return reindexMediaItems(candidates);
}

export function mediaPreviewLooksVideo(item: MediaItem): boolean {
  return item.type === "video";
}

export function mediaPreviewLooksImage(item: MediaItem): boolean {
  return item.type === "image";
}
